export enum MetricValues {
	TOP_BOX = 'TOP_BOX',
	BOTTOM_BOX = 'BOTTOM_BOX',
	MIDDLE_BOX = 'MIDDLE_BOX',
	OTHER_BOX = 'OTHER'
}
